import AppointmentWhat from './AppointmentWhat'

export default AppointmentWhat